'use strict';
module.exports = require('./Badge.vue');